import Enums from '../types/api/Enums';

export const DISPATCH_SYSTEM_NAMES: Record<Enums.IntegrationType, string> = {
  [Enums.IntegrationType.Series]: 'COMMANDseries',
  [Enums.IntegrationType.Sysdyne]: 'ConcreteGo',
  [Enums.IntegrationType.Integra]: 'Command Integra',
  [Enums.IntegrationType.Apex]: 'Command Apex',
  [Enums.IntegrationType.Connect]: 'Command Cloud',
  [Enums.IntegrationType.Bcmi]: 'BCMI',
  [Enums.IntegrationType.Keystone]: 'Keystone',
  [Enums.IntegrationType.Fastweigh]: 'FastWeigh',
  [Enums.IntegrationType.Aggregatego]: 'AggregateGo',
};

// Why a quote isn't exported, given the dispatch system's name. Fixing a cause the user owns
// exports nothing by itself: only the next save does.
export const QUOTE_EXPORT_REASONS: Record<Enums.QuoteExportReason, (system: string) => string> = {
  [Enums.QuoteExportReason.Unknown]: () => 'Export failed unexpectedly. Contact Slabstack support.',
  [Enums.QuoteExportReason.NoCustomer]: () =>
    'The quote has no customer. Add one, then save the quote to export it.',
  [Enums.QuoteExportReason.NoDispatchCustomer]: (system) =>
    `The customer isn't linked to a ${system} customer. Link one, then save the quote to export it.`,
  [Enums.QuoteExportReason.ProductWithoutExternalID]: (system) =>
    `A product on the quote isn't in ${system}. Replace it, then save the quote to export it.`,
  [Enums.QuoteExportReason.MissingProjectAddress]: (system) =>
    `${system} needs a full project address with a map pin, or mark it pickup.`,
  [Enums.QuoteExportReason.InvalidProjectDates]: () =>
    'Project end date is before the start date, or too far out.',
  [Enums.QuoteExportReason.InvalidContact]: (system) =>
    `${system} rejected a quote contact. Check its email, or re-add it.`,
  [Enums.QuoteExportReason.NotConfigured]: (system) =>
    `${system} isn't set up for this quote. Contact Slabstack support.`,
  [Enums.QuoteExportReason.Rejected]: (system) =>
    `${system} rejected the quote. Contact Slabstack support.`,
  [Enums.QuoteExportReason.Unavailable]: (system) =>
    `Couldn't reach ${system}. Slabstack retries for some time, or save the quote to try again now.`,
};
